import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {IFaqMessagePayload} from '../../SERVICE-INTERFACES'

const faq_endpoints = APIS_ENDPOINTS.faq

export const request_create = async ({Content, Question, Id}: IFaqMessagePayload) => {
  const formData = new FormData()
  formData.append('Content', Content)
  formData.append('Question', Question)
  formData.append('Id', Id?.toString() || '')

  return http.post(faq_endpoints.create, formData)
}
export const request_edit = async ({Content, Question, Id}: IFaqMessagePayload) => {
  const formData = new FormData()
  formData.append('Content', Content)
  formData.append('Question', Question)
  formData.append('Id', Id?.toString() || '')

  return http.put(faq_endpoints.edit, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    faq_endpoints.getlist +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(faq_endpoints.delete + `?Id=${id}`)
}

export const request_unactive = async (id: number) => {
  return http.delete(faq_endpoints.unactive + `?Id=${id}`)
}

export const request_active = async (id: number) => {
  return http.put(faq_endpoints.active + `?Id=${id}`)
}
